import config from 'config';
import Utils  from 'Utils';
import slick  from 'slick-carousel';
import 'slick-carousel/slick/slick.css';


/**
 * Slick class
 */
class Slick {
  /**
   * [constructor description]
   * @return {[type]} [description]
   */
  constructor() {
    this.option = {
      autoplay      : true,
      autoplaySpeed : 3000,
      arrows        : false,
      dots          : true,
      dotsClass     : 'slick-dots',
      fade          : false,
      cssEase       : 'cubic-bezier(0.15, 0.33, 0.18, 0.99)',
      infinite      : true,
      speed         : 800,
      accessibility : false
    };

    this.init();
  }

  /**
   * slickを実行
   * @return {[type]} [description]
   */
  init() {
    let option = '';

    $('.js-slick').each((i, v) => {
      // data-optionに設定されているオプションとデフォルトのオプションをマージする
      option = $(v).data('option') ? (new Function('return ' + $(v).data('option')))() : {};
      option = $.extend({}, this.option, option);
      
      $(v).slick(option);
    });
  }
}

export default Slick;



// WEBPACK FOOTER //
// ./src/js/modules/Slick.js